import * as React from "react";
import { request } from "../../../../../services/cpln";
import { Card } from "antd";
import { CardTitle } from "../../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../../components/antd/card/CardContent";
import { formSetValue } from "../../../../gvc/testNewForm/utils";
import { CpSelect } from "../../../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../../gvc/testNewForm/CpErrorWarning";
import { useCpFormContext } from "../../../../../components/form/useCpFormContext";
import { CpErrorWarningArrayIcon } from "../../../../gvc/testNewForm/CpErrorWarningArrayIcon";

interface Props {}
export const EphemeralProviderSelf: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const [locationOptions, setLocationOptions] = React.useState<any[]>([]);

  React.useEffect(() => {
    fetchSchemaData();
  }, []);

  async function fetchSchemaData() {
    // Locations
    try {
      const { data: schemaRes } = await request({ url: "/catalog/schema/mk8s" });
      const locations: string[] = schemaRes.keys.spec.keys.provider.keys.ephemeral.keys.location.allow;
      setLocationOptions(locations.map((v) => ({ label: v, value: v })));
      formSetValue(id, `ephemeral.location`, locations[0]);
    } catch (e) {
      console.error("Failed to get locations from mk8s catalog schema");
    }
  }

  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardTitle>
          Ephemeral Provider
          <CpErrorWarningArrayIcon names={[`ephemeral.location`]} />
        </CardTitle>
        <CardContent>
          <CpFormItem>
            <CpLabel name={`ephemeral.location`}>Location</CpLabel>
            <CpSelect name={`ephemeral.location`} options={locationOptions} style={{ width: 600 }} />
            <CpErrorWarning name={`ephemeral.location`} />
          </CpFormItem>
        </CardContent>
      </Card>
    </div>
  );
};
